module.exports = __webpack_public_path__ + "static/media/chaliceCard.53924a93.png";